import { optimisticBalancesAtomDefinition } from './atoms/index.js';
import optimisticBalancesDefinition from './module/index.js';
import optimisticBalancesPluginDefinition from './plugin/index.js';
const optimisticBalances = ({ enabled = true } = {}) => {
    const definitions = [
        { definition: optimisticBalancesAtomDefinition },
        { definition: optimisticBalancesPluginDefinition, config: { enabled } },
    ];
    if (enabled) {
        definitions.push({ definition: optimisticBalancesDefinition });
    }
    return {
        id: 'optimisticBalances',
        definitions,
    };
};
export default optimisticBalances;
